import styled from 'styled-components'

import { ReactCountdownClockProps } from './types'
import { getImageSrc } from '../../utils/local-util'

export const ReactCountdownStyled = styled.div<ReactCountdownClockProps>`
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    ::after {
      background: ${(props) => `url('${getImageSrc(props.accordionIcon)}') center no-repeat`};
      width: 96px;
      height: 96px;
      background-size: 96px;
      margin: 27px 27px 27px auto;
      content: '';
      zoom: 0.65;
    }
  }
  @media (min-width: 992px) {
    ::after {
      zoom: 0.8;
    }
  }
  @media (min-width: 1200px) {
    ::after {
      zoom: 1;
    }
  }
`
